import propsFromUrl from 'core/enhancers/propsFromUrl';
import { column, row } from 'core/style';
import injectSheet, { createStyles } from 'core/style/injectSheet';
import { ITheme, WithStyles } from 'core/style/interfaces';
import SearchEventManager from 'core/utils/EventManager';
import React from 'react';
import compose from 'recompose/compose';
import SearchBox from 'site/components/search-box/SearchBox';
import CourseCalendar from './CourseCalendar';
import InCartForms from './InCartForms';
import PurchasedProducts from './PurchasedProducts';

interface IAccountCoursesProps {
    search: string;
}

export type IRefreshAfterArchiveOrDelete = (search: string) => void;

class AccountCourses extends React.Component<IAccountCoursesProps & WithStyles<typeof styles>> {
    searchEventManager: SearchEventManager;

    // Колбеки для обновления курсов при добавлении курса в архив/удалении
    refreshAfterArchiveOrDelete: IRefreshAfterArchiveOrDelete[];

    constructor(props) {
        super(props);
        this.searchEventManager = new SearchEventManager();
        this.refreshAfterArchiveOrDelete = [];
    }

    render() {
        const { classes, search } = this.props;

        return (
            <div className={classes.accountCourses}>
                <div className={classes.searchBar}>
                    <SearchBox
                        onChange={this.searchEventManager.dispatch}
                        placeholder="Поиск по мероприятиям и преподавателям"
                        search={search}
                    />
                </div>
                <div className={classes.calendarWrap}>
                    <CourseCalendar />
                </div>
                <div className={classes.coursesWrap}>
                    <InCartForms searchEventManager={this.searchEventManager} />
                    <PurchasedProducts
                        searchEventManager={this.searchEventManager}
                        refreshAfterArchiveOrDelete={this.refreshAfterArchiveOrDelete}
                        isArchiveProducts={false}
                    />
                    <PurchasedProducts
                        searchEventManager={this.searchEventManager}
                        refreshAfterArchiveOrDelete={this.refreshAfterArchiveOrDelete}
                        isArchiveProducts
                    />
                </div>
            </div>
        );
    }
}

const styles = (theme: ITheme) =>
    createStyles({
        accountCourses: {
            ...row(),
        },
        searchBar: {
            ...column(),
            marginBottom: 1.5 + 'rem',

            [theme.breakpoints.up('md')]: {
                marginTop: -1.5 + 'rem',
            },
        },
        calendarWrap: {
            ...column(),
            display: 'flex',
            marginBottom: 2 + 'rem',

            [theme.breakpoints.up('md')]: {
                ...column({ cols: 4 }),
            },

            [theme.breakpoints.up('lg')]: {
                ...column({ cols: 3 }),
            },
        },
        coursesWrap: {
            ...column(),
            display: 'flex',
            flexDirection: 'column',

            [theme.breakpoints.up('md')]: {
                ...column({ cols: 8 }),
            },

            [theme.breakpoints.up('lg')]: {
                ...column({ cols: 9 }),
            },
        },
    });

const AccountCoursesContainer = compose(
    propsFromUrl({
        query: ['search'],
    }),
    injectSheet(styles, 'AccountCourses'),
)(AccountCourses);

export default AccountCoursesContainer;
